const globalEnum = {
    resourceType: {
        'root': 0,
        'directory': 1,
        'menu': 2,
        'action': 3,
        'tab': 4,
        'group': 5
    },
    yesOrNo: {
        'Yes': [1, "是"],
        'No': [0, "否"]
    },
    gender: {
        'Male': 1,
        'Female': 0
    },
    productStatus: {
        'UP': [1, "上架"],
        'DOWN': [0, "下架"]
    },
    isEnable: {
        'DISABLE': [0, "禁用"],
        'ENABLE': [1, "启用"]
    },
    isOnline: {
        'DISABLE': [0, "下线"],
        'ENABLE': [1, "上线"]
    },
    isDistribution: {
        'DISABLE': [0, "未分发"],
        'ENABLE': [1, "已分发"]
    },
    isPublish: {
        'Yes': [1, "发布"],
        'No': [0, "取消"]
    },

}

export default globalEnum